import { createStore, createEvent, createEffect, forward } from 'effector';
import axios from 'axios';

type ThreadTargetType = 'blot' | 'text' | 'image-point' | 'task' | 'cell';
interface ThreadInfo {
  comments: number;
  notFound: boolean;
  unreadComments: number;
  targetDetails: {
    x: number;
    y: number;
    color: string;
  };
  thread: {
    attachmentId: string;
    blotId: string;
    createdAt: number;
    globalId: string;
    noteGlobalId: string;
    orgId: string;
    resolved: boolean;
    target: ThreadTargetType;
    updatedAt: number;
    userId: number;
    workspaceId: string;
  };
}

export const $webEditorComments = createStore<ThreadInfo[]>([]);

interface UpdateCommentsEventPayload {
  gatewayUrl: string;
  workspaceId: string;
  noteId: string;
  sessionId: string;
  eventName?: string;
  threadId?: string;
}

export const webEditorUpdateCommentsEvent = createEvent<UpdateCommentsEventPayload>('update webEditor event');

const getThreadsInfoFx = createEffect(
  async (
    payload: UpdateCommentsEventPayload
  ): Promise<{ comments: ThreadInfo[]; payload: UpdateCommentsEventPayload }> => {
    const { data } = await axios.get<ThreadInfo[]>(
      `${payload.gatewayUrl}/svc:comment/workspaces/${payload.workspaceId}/notes/${payload.noteId}/threadsInfo`,
      { headers: { 'everhelper-session-id': payload.sessionId } }
    );
    return { comments: data, payload };
  }
);

forward({
  from: webEditorUpdateCommentsEvent,
  to: getThreadsInfoFx,
});

$webEditorComments.on(getThreadsInfoFx.doneData, (store, { comments, payload }) => {
  let stateComments = [...store];

  // on comments:threadDeleted event should remove thread from store
  if (payload.eventName === 'comments:threadDeleted') {
    stateComments = stateComments.filter(({ thread }) => thread.globalId !== payload.threadId);
  }

  comments.forEach((comment) => {
    if (stateComments.find(({ thread }) => thread.globalId === comment.thread.globalId)) {
      const stateIndex = stateComments.findIndex(({ thread }) => thread.globalId === comment.thread.globalId);
      if (stateIndex !== -1) {
        stateComments = [...stateComments.slice(0, stateIndex), comment, ...stateComments.slice(stateIndex + 1)];
      }
    } else {
      stateComments.push(comment);
    }
  });
  return stateComments;
});
